module.exports = __webpack_public_path__ + "img/unlock.39fe8c87.svg";